'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function MMFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-hdrrt8rdc", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-hdrrt8rdc)" }, /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 16h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#5eaa22", d: "M0 8h32v8H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#ffd018", d: "M0 0h32v8H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M16.062 15.975l-5.15 3.275 1.727-5.733-3.674-3.745 5.065-.11 2.241-5.66 2.042 5.734 5.053.088-3.797 3.814 1.773 5.454z"
      }
    )))
  );
}

export { MMFlag };
//# sourceMappingURL=MM.mjs.map
